interface ReportIconProps {
  size?: number;
}

export const EmployeesReportIcon = ({ size = 16 }: ReportIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="9" cy="8" r="4" />
    <path d="M2 21c0-4 3.5-6 7-6s7 2 7 6" />
    <path d="M16 4a4 4 0 010 8" />
    <path d="M22 21c0-3-2-5-5-5.5" />
  </svg>
);

export const CoursesReportIcon = ({ size = 16 }: ReportIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <rect x="3" y="5" width="18" height="11" rx="1.5" />
    <path d="M2 20h20" />
  </svg>
);
